import React, { useMemo, useState } from 'react';
import {
    AD_MEDIA_TYPES,
    DEFAULT_AD_ALLOWED_MEDIA_TYPES,
    normalizeAllowedAdMediaTypes,
} from '../utils/adMarketplace';

export default function NewAdComponentForm({
                                               initial = null,
                                               onSubmit,
                                               onSubmitAndPublish,
                                               enablePublishButton = false,
                                               onCancel,
                                               error,
                                           }) {
    const [title, setTitle] = useState(initial?.title || 'Ad Panel');
    const [description, setDescription] = useState(initial?.description || '');
    const [allowedMediaTypes, setAllowedMediaTypes] = useState(
        normalizeAllowedAdMediaTypes(initial?.allowedMediaTypes || DEFAULT_AD_ALLOWED_MEDIA_TYPES)
    );
    const [localError, setLocalError] = useState('');

    const selectedLabel = useMemo(
        () => allowedMediaTypes.join(', '),
        [allowedMediaTypes]
    );

    const toggleMedium = (medium) => {
        setAllowedMediaTypes((prev) => {
            const has = prev.includes(medium);
            const next = has ? prev.filter((value) => value !== medium) : [...prev, medium];
            return normalizeAllowedAdMediaTypes(next);
        });
    };

    const buildPayload = () => {
        const safeTitle = String(title || '').trim();
        if (!safeTitle) {
            setLocalError('Ad panel title is required.');
            return null;
        }
        if (!allowedMediaTypes.length) { setLocalError('Select at least one accepted medium.'); return null; }
        return {
            title: safeTitle,
            description: String(description || '').trim(),
            allowedMediaTypes,
            adPlacementId: initial?.adPlacementId || '',
            campaignId: initial?.campaignId || '',
        };
    };

    const handleSave = () => {
        const payload = buildPayload();
        if (payload) onSubmit?.(payload);
    };

    const handleSaveAndPublish = () => {
        const payload = buildPayload();
        if (payload) onSubmitAndPublish?.(payload);
    };

    return (
        <div className="new-component-form ad-form">
            <h1>Ad Panel</h1>
            <label style={{ display: 'block', marginBottom: 12 }}>
                Panel Title
                <input
                    className="muulti-input"
                    value={title}
                    onChange={(event) => setTitle(event.target.value)}
                    placeholder="Sponsored offer"
                />
            </label>
            <label style={{ display: 'block', marginBottom: 12 }}>
                Placement Notes
                <textarea
                    className="muulti-textarea"
                    rows={3}
                    value={description}
                    onChange={(event) => setDescription(event.target.value)}
                    placeholder="Describe where this ad panel will sit on your space."
                />
            </label>
            <div style={{ marginBottom: 12 }}>
                <strong>Accepted Ad Media</strong>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                    {AD_MEDIA_TYPES.map((medium) => (
                        <label key={medium.value} style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                checked={allowedMediaTypes.includes(medium.value)}
                                onChange={() => toggleMedium(medium.value)}
                            />
                            {medium.label}
                        </label>
                    ))}
                </div>
                <p style={{ fontSize: 13, opacity: 0.75 }}>Selected: {selectedLabel}</p>
            </div>
            {(localError || error) ? <p className="error">{localError || error}</p> : null}
            <div className="muulti-container-button-container">
                <button className="muulti-button" type="button" onClick={handleSave}>
                    Save Panel
                </button>
                {enablePublishButton ? (
                    <button className="muulti-button" type="button" onClick={handleSaveAndPublish}>
                        Save Panel & Publish
                    </button>
                ) : null}
                <button className="muulti-button" type="button" onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </div>
    );
}

